import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isOnlineOrderDeliveryDetailsValid = createSelector(onlineOrderState, (onlineOrder) => !!onlineOrder?.data?.DeliveryDetails);
